import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import adminService from "../../Services/adminService";

class LogoutBtn extends Component {
  render() {
    return (
      <div className="logout-wrapper">
        {this.props.isLoggedIn && !this.props.isBtaxClient ? (
          <Button className="mr-20 mt-20" onClick={this.logout} color="primary" variant="contained" size="small">
            <i className="material-icons width40">exit_to_app</i>
          </Button>
        ) : null}
      </div>
    );
  }

  logout = async () => {
    const loggedOut = await adminService.logUserOut();
    if (!loggedOut.success) return;
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("role");
    localStorage.removeItem("isLoggedin");
    window.location.href = "/";
  };
}

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.authReducer.isLoggedIn,
    isBtaxClient: state.btaxReducer.isBtaxClient
  };
};

export default connect(mapStateToProps)(LogoutBtn);
